import { useRouter } from 'next/router';
import * as React from 'react';

import { IFileSearch } from '@/client/legacy-shared-modules/search/search-types';
import { FileHit } from '@/imports/ui/components/search/FileHits';

import { ResultsListContainer } from '../results/ResultsListContainer';

export const FilesList: React.FC<{
  hits: IFileSearch[];
}> = ({ hits }) => {
  const router = useRouter();
  const queryToken = React.useMemo(() => {
    if (!router.isReady) return '';
    const raw = router.query.queryToken;
    return typeof raw === 'string' ? raw.trim() : '';
  }, [router.isReady, router.query.queryToken]);

  if (hits.length === 0) {
    return null;
  }

  return (
    <ResultsListContainer index="files">
      {hits.map((fileHit) => (
        <React.Fragment key={fileHit.objectID}>
          {FileHit(fileHit, 'searchSidebar', true, {
            href: {
              pathname: '/aiAskResults',
              query: {
                ...(queryToken ? { queryToken } : {}),
                versionFileId: fileHit.objectID,
              },
            },
            shallow: true,
          })}
        </React.Fragment>
      ))}
    </ResultsListContainer>
  );
};
